import WebApi from '@/views/loyalty/shared/modules/web_api'
import { unwrapEnvelope, buildQuery } from '@/views/skud/shared/modules/skud-http'

export class SkudAuditEndpoint {
  constructor () {
    this.url = `${process.env.VUE_APP_CHARON_URL}api/management/`
    this.webApi = new WebApi()
  }

  // params: from,to,entity_table,actor,entity_id,action,limit — все опциональны.
  // placeId не задан -> client-scope GET /audit/list. -> {items} или null.
  async getAudit (placeId, params) {
    const seg = placeId ? 'places/' + placeId + '/' : ''
    const res = await this.webApi.get(this.url + seg + 'audit/list?' + buildQuery(params || {}))
    this.lastError = res
    return unwrapEnvelope(res)
  }
}
